import { render, staticRenderFns } from "./effective-price-breakdown.vue?vue&type=template&id=22578406&scoped=true&"
import script from "./effective-price-breakdown.vue?vue&type=script&lang=js&"
export * from "./effective-price-breakdown.vue?vue&type=script&lang=js&"
import style0 from "./effective-price-breakdown.vue?vue&type=style&index=0&id=22578406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22578406",
  null
  
)

export default component.exports